import React, { Component } from 'react';
import { FormGroup, Alert, Button, Spinner } from 'reactstrap';
import Select from 'react-select';

class EditBoxJobQueueItemForm extends Component {
    state = {
        loading: true,
        submitting: false,
        queueItem: null,
        boxJob: null,
        designs: [],
        selectedDesignId: null,
        selectedDesignLabel: '',
        error: '',
    };

    componentDidMount = () => {
        this.fetchQueueItem();
    };

    fetchQueueItem = async () => {
        const { boxJobId, queueItemId } = this.props;
        const token = JSON.parse(localStorage.getItem('token'));

        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/api/v4/box_jobs/${boxJobId}/box_job_queue_items/${queueItemId}/edit`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await res.json();
            const queueItem = data.box_job_queue_item || data;
            const boxJob = data.box_job || this.props.boxJob || null;

            this.setState({ queueItem, boxJob }, this.fetchDesigns);
        } catch (err) {
            this.setState({ loading: false, error: 'Failed to load queue item.' });
        }
    };

    getEnclosureType = () => {
        const { queueItem, boxJob } = this.state;
        return (
            (boxJob && boxJob.enclosure_type) ||
            this.props.enclosureType ||
            (queueItem && queueItem.enclosure_type) ||
            ''
        );
    };

    fetchDesigns = async () => {
        const { queueItem } = this.state;
        const enclosureType = this.getEnclosureType();
        const isDrill = queueItem && queueItem.service_type === 'drill';
        const token = JSON.parse(localStorage.getItem('token'));

        const url = isDrill
            ? `${process.env.REACT_APP_API_URL}/api/v4/box_designs?enclosure_type=${enclosureType}`
            : `${process.env.REACT_APP_API_URL}/api/v4/box_uv_designs?enclosure_type=${enclosureType}`;

        try {
            const res = await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
            const data = await res.json();

            if (isDrill) {
                const designs = (data.box_designs || []).map((d) => ({
                    value: d.id,
                    label: `${d.enclosure_type} - ${d.name} (Holes: ${d.hole_count})`,
                    hole_count: d.hole_count,
                    has_lid: d.has_lid
                }));
                const currentId = queueItem.box_design_id || null;
                const currentName = queueItem.box_design_name;
                this.setState({
                    designs,
                    selectedDesignId: currentId,
                    selectedDesignLabel: currentName
                        ? `${enclosureType} - ${currentName}`
                        : 'Select Drill Design',
                    loading: false
                });
            } else {
                const boxSide = queueItem.box_side;
                const designs = (data.box_uv_designs || [])
                    .filter((d) => d.box_side === boxSide)
                    .map((d) => ({
                        value: d.id,
                        label: `${d.enclosure_type} - ${d.name}`,
                        box_side: d.box_side
                    }));
                const currentId = queueItem.box_uv_design_id || null;
                const currentName = queueItem.box_uv_design_name;
                this.setState({
                    designs,
                    selectedDesignId: currentId,
                    selectedDesignLabel: currentName
                        ? `${enclosureType} - ${currentName}`
                        : `Select Side ${boxSide} UV Design`,
                    loading: false
                });
            }
        } catch (err) {
            this.setState({ loading: false, error: 'Failed to load designs.' });
        }
    };

    handleDesignChange = (e) => {
        if (e) {
            this.setState({ selectedDesignId: e.value, selectedDesignLabel: e.label });
        }
    };

    handleSubmit = async () => {
        const { boxJobId, queueItemId, onSaved } = this.props;
        const { queueItem, selectedDesignId } = this.state;

        if (!queueItem) return;
        if (!selectedDesignId) {
            this.setState({ error: 'Please select a design.' });
            return;
        }

        const isDrill = queueItem.service_type === 'drill';
        const body = isDrill
            ? { box_design_id: selectedDesignId }
            : { box_uv_design_id: selectedDesignId };

        const token = JSON.parse(localStorage.getItem('token'));
        this.setState({ submitting: true, error: '' });

        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/api/v4/box_jobs/${boxJobId}/box_job_queue_items/${queueItemId}`,
                {
                    method: 'PUT',
                    headers: {
                        Authorization: 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            );
            const data = await res.json();

            if (data.errors) {
                const msg = typeof data.errors === 'string'
                    ? data.errors
                    : Object.keys(data.errors).map((k) => `${k} ${data.errors[k]}`).join(', ');
                this.setState({ submitting: false, error: msg });
                return;
            }

            this.setState({ submitting: false });
            if (onSaved) onSaved(data);
        } catch (err) {
            this.setState({ submitting: false, error: 'Failed to save.' });
        }
    };

    renderQueueItemAttributes = () => {
        const { queueItem, boxJob } = this.state;
        const enclosureType = this.getEnclosureType();
        const powderColor = (boxJob && boxJob.powder_color) || this.props.powderColor || '';
        const isDrill = queueItem.service_type === 'drill';
        const serviceLabel = isDrill ? 'Drill' : `UV — Side ${queueItem.box_side}`;

        return (
            <div className="mb-3">
                <div><strong>Enclosure:</strong> {enclosureType} {powderColor}</div>
                <div><strong>Service:</strong> {serviceLabel}</div>
                <div><strong>Product:</strong> {queueItem.product_name} ({queueItem.product_sku})</div>
                <div><strong>Quantity:</strong> {queueItem.qty}</div>
                {queueItem.box_job_flags && queueItem.box_job_flags.length > 0 && (
                    <div className="mt-2">
                        <strong>Flags:</strong>
                        {queueItem.box_job_flags.map((flag, i) => (
                            <div key={i} className="alert alert-danger p-1 mb-1 mt-1" style={{ fontSize: '0.8rem' }}>
                                {flag.customer_label}
                            </div>
                        ))}
                    </div>
                )}
                {queueItem.note_image_url && (
                    <div className="mt-2">
                        <a href={queueItem.note_image_url} target="_blank" rel="noopener noreferrer">
                            <img
                                src={queueItem.note_image_thumb_url}
                                alt="Note"
                                className="img-fluid"
                                style={{ maxWidth: '120px' }}
                            />
                        </a>
                    </div>
                )}
            </div>
        );
    };

    render() {
        const { loading, queueItem, designs, selectedDesignId, selectedDesignLabel, error, submitting } = this.state;

        if (loading) {
            return (
                <div className="text-center p-3">
                    <Spinner size="sm" /> Loading…
                </div>
            );
        }

        if (!queueItem) {
            return <Alert color="danger">{error || 'Queue item not found.'}</Alert>;
        }

        const isDrill = queueItem.service_type === 'drill';
        const designLabel = isDrill ? 'Drill Design' : `Side ${queueItem.box_side} UV Design`;

        return (
            <div>
                {this.renderQueueItemAttributes()}

                <FormGroup>
                    <label className="col-form-label"><strong>Change {designLabel}</strong></label>
                    <Select
                        key="design"
                        name="design"
                        isClearable={false}
                        value={{ value: selectedDesignId, label: selectedDesignLabel }}
                        onChange={this.handleDesignChange}
                        options={designs}
                    />
                    {designs.length === 0 && (
                        <small className="text-muted">
                            No {isDrill ? 'drill' : 'UV'} designs available for this enclosure type{!isDrill && ` and side ${queueItem.box_side}`}.
                        </small>
                    )}
                </FormGroup>

                {error && <Alert color="danger">{error}</Alert>}

                <div className="text-right">
                    <Button color="success" onClick={this.handleSubmit} disabled={submitting || !selectedDesignId}>
                        {submitting ? 'Saving…' : 'Save Design'}
                    </Button>
                </div>
            </div>
        );
    }
}

export default EditBoxJobQueueItemForm;
